import React, {PropTypes as T} from 'react';
import clamp from 'lodash/clamp';
import MinusIcon from '../icons/icon_minus2';
import PlusIcon from '../icons/icon_plus2';
import cn from 'classnames';

export default class QuantitySelector extends React.Component {
  static propTypes = {
    quantity:  T.number,
    increment: T.number, // defaults to 1
    min:       T.number, // defaults to 0
    max:       T.number, // defaults to no max
    onChange:  T.func
  };

  static defaultProps = {
    min: 0,
    max: Number.MAX_SAFE_INTEGER,
    quantity: 0,
    increment: 1
  };

  state = {
    quantity: this.props.quantity
  };

  incrementQuantity = () => {
    this.sendUpdate(this.state.quantity + this.props.increment);
  };

  decrementQuantity = () => {
    this.sendUpdate(this.state.quantity - this.props.increment);
  };

  sendUpdate = (val) => {
    const newVal = clamp(val, this.props.min, this.props.max);
    this.setState({quantity: newVal}, () => {
      this.props.onChange(newVal);
    });
  };

  render () {
    const cannotDecrement = this.state.quantity <= this.props.min;
    const cannotIncrement = this.state.quantity >= this.props.max;

    const valueClasses = cn({
      'quantityselector__value': true,
      'quantityselector__value--zero': (this.state.quantity === 0)
    });

    return (
      <div className="quantityselector" data-component="quantityselector">
        <span className={valueClasses}>
          {this.state.quantity}
        </span>
        <button
          className="quantityselector__button--minus"
          data-component="quantityselector-minus"
          disabled={cannotDecrement}
          onClick={this.decrementQuantity}>
          <div><MinusIcon width={13} height={13} /></div>
        </button>
        <button
          className="quantityselector__button--plus"
          data-component="quantityselector-plus"
          disabled={cannotIncrement}
          onClick={this.incrementQuantity} >
          <div><PlusIcon width={13} height={13} /></div>
        </button>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./frontend/react/components/common/quantity_selector/index.js